import { CORE_CATEGORIES } from "@/lib/data";
import { Zap, Battery, Sun, Snowflake } from "lucide-react";

const ICONS = { "C-01": Zap, "C-02": Battery, "C-03": Sun, "C-04": Snowflake };

export default function CoreSpecialization() {
  return (
    <section
      id="core"
      data-testid="core-section"
      className="border-b border-damita-border"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-16 md:py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-16">
          <div className="col-span-12 lg:col-span-7">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-damita-ink2 mb-6 flex items-center gap-3">
              <span className="w-8 tick-line" /> Core Specialization
            </div>
            <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[0.95]">
              Complete power backup &amp; <br />
              <span className="text-damita-blue">data centre cooling solutions.</span>
            </h2>
          </div>
          <p className="col-span-12 lg:col-span-5 text-damita-ink2 text-base md:text-lg lg:pt-8">
            Four specialised product lines covering every layer of your power and cooling
            stack — from a single rack-mount UPS to a self-contained data centre cabinet.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-px bg-damita-border border border-damita-border">
          {CORE_CATEGORIES.map((c) => {
            const Icon = ICONS[c.code] || Zap;
            return (
              <div
                key={c.code}
                data-testid={`core-${c.code}`}
                className="col-span-12 md:col-span-6 lg:col-span-3 bg-white p-6 md:p-8 group hover:bg-damita-blue hover:text-white transition-colors"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-12 h-12 grid place-items-center bg-damita-surface group-hover:bg-white/10 transition-colors">
                    <Icon size={22} strokeWidth={2} />
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] opacity-70">
                    {c.code}
                  </div>
                </div>
                <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mb-5">
                  {c.title}
                </h3>
                <ul className="space-y-2.5 border-t border-damita-border group-hover:border-white/20 pt-5">
                  {c.items.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-sm">
                      <span className="mt-1.5 w-3 h-px bg-damita-ink2 group-hover:bg-damita-yellow shrink-0" />
                      <span className="opacity-90">{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
